import { StytchB2B } from '@stytch/react/b2b';
import { B2BProducts, AuthFlowType } from '@stytch/vanilla-js';

const DiscoveryLogin = () => {
  const config = {
    authFlowType: AuthFlowType.Discovery,
    products: [B2BProducts.emailMagicLinks, B2BProducts.passwords],
    sessionOptions: {
      sessionDurationMinutes: 600,
    },
    emailMagicLinksOptions: {
      discoveryRedirectURL: `${window.location.origin}/authenticate`,
    },
  };

  return (
    <div>
      <StytchB2B config={config} />
    </div>
  );
};

export default DiscoveryLogin;
